import { CarrierActionList } from "../../../crm/src/CarrierActionList";
import { TableComment } from "../../../general/src/TableComment";
import { TableContact } from "../../../general/src/TableContact";
import { TableCustomClassifications } from "../../../general/src/TableCustomClassifications";
import { TableDrivers } from "../../../general/src/TableDrivers";
import { CarrierOfferList } from "../../../powerbroker/src/CarrierOfferList";
import { ManageCarrierCapacity } from "../../../powerbroker/src/ManageCarrierCapacity";
import { BillToOverrideTable } from "../BillToOverrideTable";
import { CarrierQualification } from "../CarrierQualification";
import { LanePreferenceTable } from "../LanePreferenceTable";
import { LaneSendToContacts } from "../LaneSendToContacts";
import { Button, Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, StarRating, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrier extends Layout {
    LastContactedBy: Textbox;
    btnCimVendorUrl: Button;
    buttonAvailableLoads: Button;
    buttonAvailableTractors: Button;
    buttonCallinHistory: Button;
    buttonCarrierPlan: Button;
    buttonCarrierUsers: Button;
    buttonLaneHistory: Button;
    buttonMonitorCarrier: Button;
    buttonOpenClassic: Button;
    buttonOverrideCarrier: Button;
    buttonViewPayee: Button;
    checkboxAir: Checkbox;
    checkboxExcludeCarrier: Checkbox;
    checkboxExpedited: Checkbox;
    checkboxIntermodal: Checkbox;
    checkboxLTL: Checkbox;
    checkboxOcean: Checkbox;
    checkboxPartial: Checkbox;
    checkboxTruckload: Checkbox;
    citystatePayeeCityId: CityState;
    citystate_: CityState;
    contAutoLiabilityPanel: Panel;
    contCargoLiabilityPanel: Panel;
    dataheaderCarrier: DataHeader;
    generalLiabilityAmount: Textbox;
    generalLiabilityCancellationDate: Textbox;
    generalLiabilityCompany: Textbox;
    generalLiabilityExpirationDate: Textbox;
    generalLiabilityInsurancePanel: Panel;
    generalLiabilityPhone: Textbox;
    generalLiabilityPolicyNum: Textbox;
    horizontalspacer1: HorizontalSpacer;
    interchangeInsurancePanel: Panel;
    labelAddress2: Label;
    labelAlertOverride: Label;
    labelAuthorityGranted: Label;
    labelAuthorityReinstated: Label;
    labelAuthorityStatus: Label;
    labelBillToOverride: Label;
    labelCargoAuthorization: Label;
    labelCargoInsurance: Label;
    labelCarrierModes: Label;
    labelCarrierStats: Label;
    labelContingentAutoInsurance: Label;
    labelContingentCargoInsurance: Label;
    labelDash: Label;
    labelDashboardLink: Label;
    labelDateRangeStar: Label;
    labelExpireOverride: Label;
    labelGeneralLiabilityInsurance: Label;
    labelHeaderCarAddr1: Label;
    labelHeaderCarCSZ: CityState;
    labelHeaderCarName: Textbox;
    labelHeaderContactEmail: Label;
    labelHeaderContactName: Textbox;
    labelHeaderContactPhone: Label;
    labelIsoCarrierScorecard: Label;
    labelLiabilityInsurance: Label;
    labelM: Label;
    labelOnboarding: Label;
    labelPendingAuthority: Label;
    labelPendingRevocation: Label;
    labelStart: Label;
    labelTrailerInsurance: Label;
    labelVendor: Label;
    labelWorkersCompInsurance: Label;
    layoutBillToOverrideTable: BillToOverrideTable;
    layoutCarrierActionList: CarrierActionList;
    layoutCarrierOfferList: CarrierOfferList;
    layoutCustomClassifiications: TableCustomClassifications;
    layoutImageTable: Layout;
    layoutLanePreferenceTable: LanePreferenceTable;
    layoutLaneSendToContacts: LaneSendToContacts;
    layoutManageCarrierCapacity: ManageCarrierCapacity;
    layoutQualification: CarrierQualification;
    layoutTableComment: TableComment;
    layoutTableContact: TableContact;
    layoutTableDrivers: TableDrivers;
    panel1: Panel;
    panel2: Panel;
    panel32: Panel;
    panel33: Panel;
    panel34: Panel;
    panel3: Panel;
    panelAuthority: Panel;
    panelAuthorityGranted: Panel;
    panelAuthorityReinstated: Panel;
    panelAuthorityStatus: Panel;
    panelBasicInfo1: Panel;
    panelBasicInfo2: Panel;
    panelBasicInfo3: Panel;
    panelCTPAT: Panel;
    panelCargoAuthLeft: Panel;
    panelCargoAuthRight: Panel;
    panelCargoAuthorization: Panel;
    panelCargoInsurance: Panel;
    panelCargoInsuranceInfo: Panel;
    panelCargoInsuranceSwitches: Panel;
    panelCarrierInsMonitoringLicensed: Panel;
    panelCarrierModes: Panel;
    panelCarrierOverride: Panel;
    panelCarrierStatisitcs: Panel;
    panelCarrierStats: Panel;
    panelCategory: Panel;
    panelContingentAutoInsurance: Panel;
    panelContingentCargoInsurance: Panel;
    panelCreditApproval: Panel;
    panelDOTSafety: Panel;
    panelDates: Panel;
    panelDispatch: Panel;
    panelGeneral: Panel;
    panelGeneralLiabilityInsurance: Panel;
    panelHazmat: Panel;
    panelHeader: Panel;
    panelHeaderCarrier: Panel;
    panelHeaderContact: Panel;
    panelInsuranceInfo1: Panel;
    panelInsuranceInfo3: Panel;
    panelInsuranceInfo4: Panel;
    panelIsoScoreDetails: Panel;
    panelLanePreferenceDisplay: Panel;
    panelLiabilityInsurance: Panel;
    panelMCS: Panel;
    panelMonitor: Panel;
    panelOnboarding: Panel;
    panelOnboardingAlertOverride: Panel;
    panelOnboardingExpireOverride: Panel;
    panelP44Settings: Panel;
    panelPendingAuthority: Panel;
    panelPendingRevocation: Panel;
    panelPerformance: Panel;
    panelPnnComments: Panel;
    panelPnnOptions: Panel;
    panelProfile: Panel;
    panelRating: Panel;
    panelRiskAssessment: Panel;
    panelSafety: Panel;
    panelSafetyRegistration: Panel;
    panelScorecardHeader: Panel;
    panelStatus: Panel;
    sourceAgencyLink: DataSource;
    sourceBolBillToOverride: DataSource;
    sourceCarrier: DataSource;
    sourceCarrierAction: DataSource;
    sourceCarrierDriver: DataSource;
    sourceCarrierInsurance: DataSource;
    sourceCarrierPerfCalculation: DataSource;
    sourceCarrierPerformanceMetric: DataSource;
    sourceCarrierPerformanceMetricBr: DataSource;
    sourceCarrierScorecard: DataSource;
    sourceClassifications: DataSource;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceDrsPayeeEquip: DataSource;
    sourceInsightComments: DataSource;
    sourcePNNLane: DataSource;
    sourcePnnBuilderSendto: DataSource;
    starratingS: StarRating;
    switchActivePNNCarrier: Switch;
    switchAnyAutos: Switch;
    switchBondFiled: Switch;
    switchBondRequired: Switch;
    switchCTPAT: Switch;
    switchCargoInsOnFile: Switch;
    switchCargoInsuranceReq: Switch;
    switchCarrierContract: Switch;
    switchCertificationofInsuranceonFile: Switch;
    switchCreditApproved: Switch;
    switchDisableAutomatedTracking: Switch;
    switchDisableElectronicOffers: Switch;
    switchExcludeCarrier: Switch;
    switchHiredAutos: Switch;
    switchHouseholdGoods: Switch;
    switchInsuranceUpdates: Switch;
    switchIntraCanada: Switch;
    switchIntrastateOnly: Switch;
    switchIsBroker: Switch;
    switchIsCertifiedRMI: Switch;
    switchLanePreferenceDisplay: Switch;
    switchMacroPointOnboarded: Switch;
    switchMonitor: Switch;
    switchNoDispatch: Switch;
    switchNonOwnedAutos: Switch;
    switchOutOfService: Switch;
    switchOverrideQualificationEnforcement: Switch;
    switchOwnedAutos: Switch;
    switchPassenger: Switch;
    switchPayAdvances: Switch;
    switchPayeeFreightMatchingOverride: Switch;
    switchPendBrokerAuth: Switch;
    switchPendCommonAuth: Switch;
    switchPendContractAuth: Switch;
    switchPendRevBroker: Switch;
    switchPendRevCommon: Switch;
    switchPendRevContract: Switch;
    switchProperty: Switch;
    switchQuickpayEnabled: Switch;
    switchReeferIns: Switch;
    switchRequirementDispatchOverride: Switch;
    switchScheduledAutos: Switch;
    switchW9OnFile: Switch;
    switchWatchdogReport: Switch;
    tabActivities: Tab;
    tabAdditionalInsuranceTypes: Tab;
    tabAuthority: Tab;
    tabBillingAccelerator: Tab;
    tabCarrierCapacity: Tab;
    tabCarrierInsights: Tab;
    tabComments: Tab;
    tabContacts: Tab;
    tabCustomClassifications: Tab;
    tabDrivers: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabInsurance: Tab;
    tabIsoScorecard: Tab;
    tabLTL: Tab;
    tabLanePreference: Tab;
    tabLogix: Tab;
    tabLogixOnboarding: Tab;
    tabOffers: Tab;
    tabOperations: Tab;
    tabPnnOptions: Tab;
    tabQualifications: Tab;
    tabRating: Tab;
    tabScorecard: Tab;
    tabScorecardDetails: Tab;
    tabTrackingOptions: Tab;
    tabTrailerTypes: Tab;
    tableInsights: Table;
    tableScoreCardDetails: Table;
    tableTrailerTypes: Table;
    tabset1: Tabset;
    tabsetAdditionalInsurance: Tabset;
    tabsetLogixSolutions: Tabset;
    tabsetMain: Tabset;
    tabsetPnnOptions: Tabset;
    textboxActivityStatus: Textbox;
    textboxAgreementDt: Textbox;
    textboxAuthReinstateDate: Textbox;
    textboxAutoCreateDispatchTractr: Textbox;
    textboxAverageDistance: Textbox;
    textboxAverageMargin: Textbox;
    textboxAverageRevenue: Textbox;
    textboxBrokerAuthGrantDate: Textbox;
    textboxBrokerAuthStatus: Textbox;
    textboxCancellationDate: Textbox;
    textboxCargoAmount: Textbox;
    textboxCargoCancelDate: Textbox;
    textboxCargoCompany: Textbox;
    textboxCargoEmail: Textbox;
    textboxCargoExpDate: Textbox;
    textboxCargoFax: Textbox;
    textboxCargoPhone: Textbox;
    textboxCargoPolicyNum: Textbox;
    textboxCarrierContractAlert: Textbox;
    textboxCarrierContractExpire: Textbox;
    textboxCarrierManager: Textbox;
    textboxCarrierOnboarding: Textbox;
    textboxCarrierPlan: Textbox;
    textboxCarrierProfileAlert: Textbox;
    textboxCarrierProfileExpire: Textbox;
    textboxCarrierTrackID: Textbox;
    textboxCategory: Textbox;
    textboxClass: Textbox;
    textboxComAuthReinstateDate: Textbox;
    textboxCommonAuthGrantDate: Textbox;
    textboxCommonAuthStatus: Textbox;
    textboxCompDate: Textbox;
    textboxContAuthReinstateDate: Textbox;
    textboxContAutoAmount: Textbox;
    textboxContAutoCancellationDate: Textbox;
    textboxContAutoCompany: Textbox;
    textboxContAutoExpirationDate: Textbox;
    textboxContAutoPhone: Textbox;
    textboxContAutoPolicyNum: Textbox;
    textboxContCargoAmount: Textbox;
    textboxContCargoCancellationDate: Textbox;
    textboxContCargoCompany: Textbox;
    textboxContCargoExpirationDate: Textbox;
    textboxContCargoPhone: Textbox;
    textboxContCargoPolicyNum: Textbox;
    textboxContractAuthGrantDate: Textbox;
    textboxContractAuthStat: Textbox;
    textboxCreditCheckDate: Textbox;
    textboxDefLoadToRadius: Textbox;
    textboxDefLocRadius: Textbox;
    textboxDocumentRequestAlert: Textbox;
    textboxDocumentRequestExpire: Textbox;
    textboxDocumentTrackID: Textbox;
    textboxDotNumber: Textbox;
    textboxDrivers: Textbox;
    textboxExpirations: Textbox;
    textboxExpiringTrackID: Textbox;
    textboxGrossMargin: Textbox;
    textboxHazmatCertNumber: Textbox;
    textboxHazmatExpireDate: Textbox;
    textboxHighwayIdNumber: Textbox;
    textboxHighwayRuleAssessment: Textbox;
    textboxHighwayStatus: Textbox;
    textboxIccNumber: Textbox;
    textboxId: Textbox;
    textboxInsLastUpdDt: Textbox;
    textboxInsuranceExpEmails: Textbox;
    textboxInterchangeExpirationDate: Textbox;
    textboxIntrastateCode: Textbox;
    textboxIntrastateState: Textbox;
    textboxKpiBouncedBookings: Textbox;
    textboxKpiOnTimeDelivery: Textbox;
    textboxKpiOnTimePickup: Textbox;
    textboxKpiScore: Textbox;
    textboxKpiTotalLoads: Textbox;
    textboxLastCalcDate: Textbox;
    textboxLastContacted: Textbox;
    textboxLeasedTractors: Textbox;
    textboxLeasedTrailers: Textbox;
    textboxLiabilityAmount: Textbox;
    textboxLiabilityEmail: Textbox;
    textboxLiabilityExpDate: Textbox;
    textboxLiabilityInsurFax: Textbox;
    textboxLiabilityInsurPhone: Textbox;
    textboxLiabilityInsurer: Textbox;
    textboxLiabilityPolicy: Textbox;
    textboxLiabilityRequired: Textbox;
    textboxMCS150mileage: Textbox;
    textboxMCSDate: Textbox;
    textboxMCSmileageyear: Textbox;
    textboxMarginPercent: Textbox;
    textboxMpwCarrierContactMethod: Textbox;
    textboxMpwCarrierHigh: Textbox;
    textboxMpwCarrierLow: Textbox;
    textboxMpwLastContact: Textbox;
    textboxMpwNumAttempts: Textbox;
    textboxMpwNumOrders: Textbox;
    textboxNumberLoads: Textbox;
    textboxNumberUnbilled: Textbox;
    textboxOverAllRisk: Textbox;
    textboxOverrideQualificationDate: Textbox;
    textboxOverrideReason: Textbox;
    textboxOwnedTractors: Textbox;
    textboxOwnedTrailers: Textbox;
    textboxP44CapacityProviderID: Textbox;
    textboxP44ProfileId: Textbox;
    textboxPayeeAddress1: Textbox;
    textboxPayeeAddress2: Textbox;
    textboxPayeeCurrency: Textbox;
    textboxPayeeLegalName: Textbox;
    textboxPayeeName: Textbox;
    textboxPayeePhoneNumber: Textbox;
    textboxPayeeStatus: Textbox;
    textboxPerformRating: Textbox;
    textboxPerformRatingDt: Textbox;
    textboxPnnCarriercomment1: Textbox;
    textboxPnnCarriercomment2: Textbox;
    textboxPnnCarrieremailProfileId: Textbox;
    textboxPnnCarrieroutputType: Textbox;
    textboxPnnCarrierreplyDetail: Textbox;
    textboxPnnCarrierreplyName: Textbox;
    textboxPnnCarrierreplyVia: Textbox;
    textboxPnnCarrierscheduleId: Textbox;
    textboxPowerUnits: Textbox;
    textboxQualificationProfile: Textbox;
    textboxRecentRanking: Textbox;
    textboxRecurTractorLastCreated: Textbox;
    textboxSMC3ProfileId: Textbox;
    textboxSSorFID: Textbox;
    textboxSVI: Textbox;
    textboxSafetyRateRevDt: Textbox;
    textboxSafetyRating: Textbox;
    textboxSafetyRatingDt: Textbox;
    textboxSafetyRegDate: Textbox;
    textboxSafetyRegStatus: Textbox;
    textboxSafetyReviewType: Textbox;
    textboxSalesperson: Textbox;
    textboxScac: Textbox;
    textboxSmc3AccountNo: Textbox;
    textboxStartDate: Textbox;
    textboxTotalMiles: Textbox;
    textboxTotalPay: Textbox;
    textboxTotalRevenue: Textbox;
    textboxTrackingMethod: Textbox;
    textboxTrailerAmount: Textbox;
    textboxTrailerCancelDate: Textbox;
    textboxTrailerCompany: Textbox;
    textboxTrailerPhone: Textbox;
    textboxTrailerPolicyNum: Textbox;
    textboxWorkersCompAmount: Textbox;
    textboxWorkersCompCancellationDate: Textbox;
    textboxWorkersCompCompany: Textbox;
    textboxWorkersCompExpirationDate: Textbox;
    textboxWorkersCompPhone: Textbox;
    textboxWorkersCompPolicyNum: Textbox;
    toggleCARB: Switch;
    toggleOnboarded: Switch;
    workersCompInsurancePanel: Panel;
}
